'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootToolbarBlockTypes = exports.stopPropagation = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.newBlockOfType = newBlockOfType;
exports.updateData = updateData;
exports.addSubNode = addSubNode;
exports.addNextNode = addNextNode;
exports.deleteNode = deleteNode;

var _slate = require('slate');

var _lodash = require('lodash');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function newBlockOfType(descriptor, blocks) {
  var _ref = typeof descriptor === 'string' ? {} : descriptor,
      _ref$data = _ref.data,
      data = _ref$data === undefined ? {} : _ref$data,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? descriptor : _ref$type;

  var rest = blocks[type] && blocks[type].template ? blocks[type].template : {};
  var block = (0, _extends3.default)({
    type: type,
    isVoid: blocks[type] ? blocks[type].isVoid : false
  }, rest, {
    data: (0, _extends3.default)({}, rest.data || {}, data)
  });
  console.log("Creating block", block);
  return _slate.Block.create(block);
}

function updateData(change, node, data) {
  console.log('Updating data', data);
  return change.setNodeByKey(node.key, {
    data: data
  });
}

function addSubNode(change, node, newBlock, after) {
  var index = after ? node.nodes.indexOf(after) + 1 : node.nodes.size;
  console.log('inserting sub node', node.toJS(), node.size, newBlock.toJS());
  var out = change.insertNodeByKey(node.key, index, newBlock);

  if (after) {
    return out.collapseToEndOf(after).focus();
  } else {
    return out.collapseToEndOf(node).focus();
  }
}

function addNextNode(change, newBlock) {
  return change.moveToEndOfBlock().insertBlock(newBlock).focus();
}

function deleteNode(change, node) {
  return change.removeNodeByKey(node.key);
}

var stopPropagation = exports.stopPropagation = function stopPropagation(e) {
  e.stopPropagation();
  e.preventDefault();
}; // It isn't very lit to have to do things twice, so we use toolbarOrder to allow us


var rootToolbarBlockTypes = exports.rootToolbarBlockTypes = (0, _lodash.memoize)(function (blocks) {
  return (0, _lodash.chain)(blocks).pickBy(function (_ref2) {
    var toolbarOrder = _ref2.toolbarOrder;
    return typeof toolbarOrder === 'number';
  }).keys().sortBy(function (key) {
    return blocks[key].toolbarOrder;
  }).value();
});